import * as React from 'react';
import { ListingState, BaseRouteProps } from '../../../interfaces';
import { ScoreCard } from '../../../models';
import { ScoreCardDataService } from '../../../services';
import { NavLink } from 'react-router-dom';
import { DataGrid } from '../../../components';
import { Button } from 'react-bootstrap';
import { LoadingIndicator } from '../../loadingIndicator/LoadingIndicator';

interface ScoreCardListingState extends ListingState<ScoreCard> {
    copyingScoreCard: boolean;
}

export class ScoreCardListing extends React.Component<BaseRouteProps<{}>, ScoreCardListingState> {
    private scoreCardDataService = new ScoreCardDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{}>) {
        super(props);

        this.state = {
            entities: new Array<ScoreCard>(),
            copyingScoreCard: false
        };
    }

    public componentDidMount() {
        this.scoreCardDataService.getAll().then((scoreCards: ScoreCard[]) => {
            this.setState(
                { entities: scoreCards }
            );
        });
    }

    public copyScoreCard(scoreCardId: number) {
        this.setState({ copyingScoreCard: true });

        this.scoreCardDataService.copy(scoreCardId)
            .then((scoreCard: ScoreCard) => {
                this.props.history.push(`/scorecards/${scoreCard.id}`);
            })
            .catch(() => this.props.notificationService.addError('Error copying score card. Please try again.'));
    }

    public render() {
        const listData = this.state.entities.map(entity => {
            return {
                'Name': entity.name,
                'Organization': entity.organization.name,
                'ActionKey': entity.id
            };
        });

        const actionsColumn = ({ value }: any) => {
            return (
                <span>
                    <Button className="btn btn-default" onClick={() => this.copyScoreCard(value)}>Copy</Button>
                    &nbsp;&nbsp;
                    <NavLink className="btn btn-default" to={`/scorecards/${value}`}>View</NavLink>
                </span>
            );
        };

        const columnDefs = [
            { id: 'Name' },
            { id: 'Organization' },
            { id: 'ActionKey', title: 'Actions', width: '150px', customComponent: actionsColumn, sortable: false }
        ];

        return (
            <div>
                <div className="content-header">
                    <div className="content-container">
                        <div className="row">
                            <div className="col-xs-7">
                                <div className="title">
                                    Score Cards
                                </div>
                            </div>
                            <div className="col-xs-5 text-right">
                                <NavLink className="btn btn-primary" to="/scorecards/create">
                                    <span className="glyphicon glyphicon-plus" /> Create
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content-body">
                    { this.state.copyingScoreCard && 
                        <LoadingIndicator showBackground={true} /> 
                    }
                    
                    <div className="content-container">
                        <DataGrid entities={listData} columns={columnDefs} />
                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/scoreCard/scoreCard/ScoreCardListing.tsx